import dynamic from 'next/dynamic';
import type { Virtuoso as VirtuosoType } from 'react-virtuoso';

export const Virtuoso = dynamic(
  () => import('react-virtuoso').then((mod) => mod.Virtuoso),
  {
    ssr: false,
  }
) as typeof VirtuosoType;
